<script lang="ts">
  import { defineAsyncComponent, defineComponent, onBeforeMount, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useGlobalStore } from '~/stores/global'
  import { useI18nStore } from '~/stores/i18n'
  import type Login from '~/components/Login/index.vue'
  import { TraceCode } from '~/utils/trace'
  export default defineComponent({
    props: {
      serviceListAllData:{
          type: Object,
          default:()=>{
          return {
              ticketServiceList:[],
              boothServiceList:[]
          }
          }
      },
      lang: {
        type: String,
        default: 'cn'
      }
    },
    setup() {
      const tokenCookie = useCookie('access_token', {
        maxAge: 60 * 60 * 24 * 7,
        domain: 'jufair.com'
      })
      const showFooter = ref(true)
      const joinVisible = ref(false)
      const isSdkReady = ref(false)
      const w = ref(0)
      const url = ref('')
      const route = useRoute()
      const router = useRouter()
      const globalStore = useGlobalStore()
      const i18nStore = useI18nStore()
      console.log('i18nStore', i18nStore.locale)

      const visibleLinks = computed(() => {
        const { path } = route
        return path === '/' || /^\/exhibition((-\d+){7}|)\/$/.test(path)
      })

      // 初始化函数
      const init = () => {
        ;(window as any).ysf('onready', () => {
          isSdkReady.value = true
        })
      }

      // 检查是否登录
      const shouldLogin = () => {
        if (!tokenCookie.value) {
          loginModal?.value.open()
          // router.push(`/login?redirect=${encodeURIComponent(route.fullPath)}`)
        }
        return !!tokenCookie.value
      }

      // 打开客服窗口
      const openkefu = () => {
        if (isSdkReady.value) {
          ;(window as any).ysf('open')
        }
      }

      const isLogin = computed(() => globalStore.isLogin)
      const loginModal = inject<typeof Login>('loginModal')
      const handleLogin = () => {
        // window.$login.show(window.$i18n);
        // console.log("loginModal", app);
        if (tokenCookie.value) {
          window.open('/manager/', '_blank')
        } else {
          loginModal?.value.open()
        }
      }

      // 打开新窗口
      const openWindow = (path: string) => {
        if (shouldLogin()) {
          window.open(path, '_blank')
        }
      }
      const handleApply = ()=>{
        window.open(
          `/exhibition/apply/${route.params.id}.html`,
          '_blank'
        );
        window.trace?.upload({
                module: TraceCode.MO_FAIR_BOOTH,
                bizId: route.params.id,
                callbackCode: TraceCode.CC_APPLY_BOOTH,
              });
      }

      // 处理 Sidebar 变化
      const sidebarChange = (e: any) => {
        w.value = e
      }
      const isShowQrcode = ref(false)
      const currentUrl = ref("")
     const mouseenterEvent = (event: any, url: any) => {
        isShowQrcode.value = true;
        currentUrl.value = url;
        const target = event.target as HTMLElement;
        const rect = target.getBoundingClientRect();
        const obj = document.getElementById('qrcodeDiv');
        if (obj) {
          obj.style.top = rect.top  + 35 + 'px';
          obj.style.left = rect.left  + 5 + 'px';
        }
      };

      // 在组件挂载时执行逻辑
      onMounted(() => {
        const routerPath = route.path
        url.value = routerPath.substr(1, routerPath.indexOf('/', 1) - 1)
      })

      onBeforeMount(() => {
        const { name } = route

        if (name === '选择支付方式') {
          showFooter.value = false
        }
      })

      // 错误捕获
      const errorCaptured = (err: any, vm: any, info: any) => {
        if (process.client) {
          const fundebug = require('fundebug-javascript')
          fundebug.notify('ErrorCaptured', info, {
            metaData: { err, vm, info }
          })
        } else {
          console.error('ErrorCaptured', err)
        }
        return false
      }

      // 配置 `head`
      const head = () => {
        const meta = [
          {
            name: 'og:image',
            content: 'https://www.jufair.com/logo.png'
          }
        ]
        let currentPageUrlStr = route.fullPath
        if (route.fullPath.includes('/seo')) {
          currentPageUrlStr = route.fullPath.split('/seo')[1]
        }

        const link = [
          {
            rel: 'canonical',
            href: `https://www.jufair.com${currentPageUrlStr}`
          }
        ]

        const head: Record<string, any> = {}
        if (
          !/exhibition\/\d+\.html/.test(route.path) &&
          !/information\/\d+\.html/.test(route.path) &&
          !/information/.test(route.path)
        ) {
          head.meta = meta
        }
        if (
          !/exhibition(-\d+){7}/.test(route.path) &&
          !/information(-\d+){3}/.test(route.path) &&
          !/information/.test(route.path)
        ) {
          head.link = link
        }

        return head
      }
      return {
        visibleLinks,
        showFooter,
        joinVisible,
        isSdkReady,
        w,
        url,
        init,
        shouldLogin,
        openkefu,
        openWindow,
        handleLogin,
        sidebarChange,
        errorCaptured,
        head,
        handleApply,
        mouseenterEvent,
        isShowQrcode,
        currentUrl
      }
    }
  })
</script>

<template>
  <div class="layout-container">
    <div
      :style="`padding-left: ${w}px`"
      class="main-container">
      <div class="slider-area2">
        <ul>
          <li class="">
              <div class="box exhibitionService">
                <img src="~/assets/icon/service6.png" alt="icon" />
                <span>{{ $t('fixed_sidebar.customer') }}</span>
                <div class="service-out-box">
                  <div class="service-box">
                    <div class="public-service">
                      <div class="public-content">
                        <p>
                          <em>{{ $t('fixed_sidebar.booth') }}:</em>
                          0571-88560061
                        </p>
                        <p>
                          <em>{{ $t('fixed_sidebar.viewer') }}:</em>
                         0571-88683357
                        </p>
                      </div>
                      <div class="online-servicce">
                        <a
                        href="JavaScript:KS.openDirChatWin()"
                        rel="nofollow"
                        :title="$t('fixed_sidebar.online_customer')"
                      >
                        <img src="~/assets/icon/online-servicce.png" alt="">
                        <p class="online-text">在线问</p>
                      </a>
                      </div>
                    </div>
                    
                    <div class="line"></div>
                    <div class="parent-ul">
                      <div class="service-ul">
                      <div v-for="(item,index) in serviceListAllData.ticketServiceList" :key="index" class="service-li"  >
                        <p class="service-type">门票咨询</p>
                        <div class="consult-info">
                          <div class="service-info">
                            <img
                              :src="item.avatar"
                              :alt="item.nickName"
                              rel="nofollow,noindex"
                            />
                            <div class="name_title">
                              <p class="nick_name">
                                <template v-if="!lang || lang == 'cn'">{{ item.nickName }}</template>
                                <template v-else>{{ item.englishNickName }}</template>
                              </p>
                              <p> {{ item.postTitleName }}</p>
                            </div>
                          </div>
                          <div class="service-phone">
                            <p>{{ $t('customerService.telephone') }}
                              {{ item.companyPhone }}</p>
                              <p>{{ $t('customerService.mobilePhone') }}
                                {{ item.companyMobile }}</p>
                          </div>
                          <div class="wechat-icon" @mouseenter="mouseenterEvent($event,item.companyWxQr)" @mouseleave = 'isShowQrcode = false'>
                            {{ $t('customerService.wechat') }}
                            <img src="~/assets/icon/wei2.png"/>
                              <!-- <div class="qrcode-area" >
                                <img
                                  class="qrcode" 
                                  :src="item.companyWxQr"
                                  alt="wechat"
                                  rel="nofollow,noindex"
                                />
                            </div> -->
                          </div>
                          <div class="line"></div>
                        </div>
                      </div>
                      <div v-for="item in serviceListAllData.boothServiceList" class="service-li"  :key="item">
                        <p class="service-type">展位咨询</p>
                        <div class="consult-info">
                          <div class="service-info">
                            <img
                              :src="item.avatar"
                              :alt="item.nickName"
                              rel="nofollow,noindex"
                            />
                            <div class="name_title">
                              <p class="nick_name">
                                <template v-if="!lang || lang == 'cn'">{{ item.nickName }}</template>
                                <template v-else>{{ item.englishNickName }}</template>
                              </p>
                              <p> {{ item.postTitleName }}</p>
                            </div>
                          </div>
                          <div class="service-phone">
                            <p>{{ $t('customerService.telephone') }}
                              {{ item.companyPhone }}</p>
                              <p>{{ $t('customerService.mobilePhone') }}
                                {{ item.companyMobile }}</p>
                          </div>
                          <div class="wechat-icon" @mouseenter="mouseenterEvent($event,item.companyWxQr)" @mouseleave = 'isShowQrcode = false'>
                            {{ $t('customerService.wechat') }}
                            <img src="~/assets/icon/wei2.png"/>
                          </div>
                          <div class="line"></div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <p class="work_time">{{ $t('customerService.workTime') }}:{{ $t('footer.work_time2') }}09:00-18:00</p>
                    <div id="qrcodeDiv" class="qrcodeDiv" v-show="isShowQrcode">
                      <img :src="currentUrl" alt="">
                    </div>
                  </div>
                </div>
                
              </div>
            </li>
          <!-- <li>
            <a
              :title="$t('fixed_sidebar.online_customer')"
              href="JavaScript:KS.openDirChatWin()"
              rel="nofollow">
              <img
                alt="icon"
                src="~/assets/icon/service.png" />
              <span>{{ $t('fixed_sidebar.customer') }}</span>
            </a>
          </li> -->
          <!-- handleLogin -->
          <!-- @click="openWindow('/manager/')" -->
          <li @click="handleLogin">
            <img
              alt="icon"
              src="~/assets/icon/my.png" />
            <span>{{ $t('fixed_sidebar.my') }}</span>
          </li>
          <li @click="openWindow('/manager/ticket-my/')">
            <img
              alt="icon"
              src="~/assets/icon/ticket.png" />
            <span>{{ $t('fixed_sidebar.vote') }}</span>
          </li>
          <li>
            <span @click="handleApply" style="margin-left: 10px;">
              {{ $t('exhibitionDetail.boothApply') }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
  <style lang="less" scoped>
  html {
    font: 16px/1.14 SF Pro Display, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
      WenQuanYi Micro Hei, Helvetica Neue, Arial, sans-serif;
    color: #222;
    word-spacing: 1px;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }
  
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
  }
  
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  
  a {
    text-decoration: none;
    color: #333;
  }
  
  .layout-container {
    min-width: 1190px;
    min-height: 0 !important;
    background: #f7f7f7;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index:100;
    .slider-area2 {
      position: fixed;
      right: 0;
      // bottom: 0.1%;
      top:120px;
      width: 50px;
      background: #fff;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      //padding: 16px 0;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
  
      ul {
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 14px;
          margin-bottom: 28px;
          cursor: pointer;
          position: relative;
          background: #fff;
          // z-index: 8;
  
          &.tel {
            &:hover .tel-no {
              left: 0;
              transform: translateX(-99%);
            }
          }
  
          .box {
            background: #fff;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 8;
            padding-top: 16px;
            border-radius: 4px 0 0 0;
          }
  
          .tel-no {
            position: absolute;
            background-color: #fff;
            left: 100%;
            top: 0;
            transform: translateX(0);
            white-space: nowrap;
            font-family: 'Helvetica Neue', sans-serif;
            font-size: 14px;
            font-weight: bold;
            padding: 8px 8px 8px 16px;
            border-radius: 4px 0 0 4px;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
            z-index: 7;
            transition: all 0.3s linear;
          }
  
          a {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 14px;
            cursor: pointer;
          }
  
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 16px;
          }
  
          &:hover {
            span {
              color: @app-color;
            }
          }
  
          span {
            margin: 4px 0 0 0;
          }
  
          img {
            width: 28px;
            height: auto;
          }
        }
      }
      &.slider-exhibition{
        bottom: 58%;
      }
    }
  }
  
  img {
    vertical-align: top;
  
    // &[data-src] {
    //   opacity: 0;
    //   transition: all 0.3s;
    // }
  }
  
  .browser {
    width: @client-width;
    margin: 0 auto;
    text-align: center;
    padding: 8px 0;
    color: #1890ff;
  }
  .exhibitionService{
    position: relative;
    .service-out-box{
        position: absolute;
        left: -277px;
        width: 277px;
        min-height: 100px;
        display: none;
      .service-box{
        position: absolute;
        top: -15px;
        left: -5px;
        width: 277px;
        background: #fff;
        padding: 20px;
        .public-service{
          height: 55px;
          display: flex;
          align-items: center;
          .public-content{
            p{
              font-size: 14px;
              color: #333;
              margin-top:10px;
              em{
                font-weight: bold;
              }
            }
          }
          .online-servicce{
            margin:10px 0 0 20px;
            font-size: 14px;
            color:#F82E08;
          }
          
        }
        .line{
          width: 100%;
          height: 0;
          border: 1px solid #ECECEC;
          transform: scale(1, 0.3);
          margin: 20px 0;
        }
        .parent-ul{
          position: relative;
        }
        .service-ul{
          max-height: 500px;
          overflow: auto;
          // overflow: hidden;
          .service-li{
            .service-type{
              font-weight: bold;
              font-size: 14px;
              color: #333;
              margin-bottom: 10px;
            }
            .consult-info{
              .service-info{
                display: flex;
                align-items: center;
                img{
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                }
                .name_title{
                  font-size: 12px;
                  color: #999;
                  margin-left:10px;
                  .nick_name{
                    font-size: 14px;
                    color: #333;
                    line-height: 26px;
                  }
                }
              }
              .service-phone{
                font-size: 14px;
                color: #333;
                line-height: 24px;
                margin:15px 0 10px 0;
              }
              .wechat-icon{
                display: flex;
                align-items: center;
                position: relative;
                width:100px;
                img{
                  margin-left:5px;
                  width: 30px;
                  height:30px;
                }
                .qrcode-area {
                  position: fixed;
                  background: #fff;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  padding:4px;
                  display: none;
                  top: 33px;
                  left: 0;
                  // overflow: hidden;
                  z-index: 999 !important;
                  .qrcode {
                    width: 150px;
                    min-height: 150px;
                    margin-left:0;
                  }
                }
                &:hover {
                  .qrcode-area {
                    display: block;
                  } 
                }
              }
              
            }
          }
        }
        .work_time{
          font-size: 12px;
          color: #999;
        }
      }
    }
    &:hover .service-out-box{
      display: block;
    }
    
  
  }
  .qrcodeDiv{
    position: fixed;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    z-index:999;
    width: 150px;
    min-height: 150px;
    img{
      width: 150px !important;
      min-height: 150px !important;
    }
  }
  </style>
